import SetData from "@/vuex/SetData";
import Status from "@/vuex/Status";
import Config from "@/vuex/Config";
import CatchFetch from "@/assets/Cache/Fetch";
import Notification from "@/assets/Helper/Notification";
import Logger from "@/assets/Helper/Logger";

let DAOCorrectItem = function () {

    this.byItemnumber = function (itemnumber, setDataItemKey) {
        Status.dispatch('setLoading', true).catch((error) => {
            Logger.error(error);
        });

        CatchFetch.cacheFirst(Config.getters.getApiHostWithLocalStr + '/v2/items/correct/' + itemnumber + '/')
            .then(json => {
                if (json.status) {
                    SetData.dispatch('setItem', {
                        key: setDataItemKey,
                        id: json.result[0]
                    }).catch((error) => {
                        Logger.error(error);
                    });

                    if (typeof json.alerts === 'object' && json.alerts.length > 0) {
                        for (let i in json.alerts) {
                            if (Object.prototype.hasOwnProperty.call(json.alerts, i)) {
                                Notification.create(json.alerts[i].title, json.alerts[i].text);
                            }
                        }
                    }
                }
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
            })
            .catch((error) => {
                Status.dispatch('setLoading', false).catch((error) => {
                    Logger.error(error);
                });
                Logger.error(error);
            });
    }
};

export default new DAOCorrectItem();